import { HashRouter as Router, Routes, Route } from "react-router-dom";
import { AppNavigationProvider } from "../../hooks/useAppNavigation";
import { ShellAppLauncher } from "./ShellAppLauncher";
import { ShellApp } from "./ShellApp";

export function Shell() {
  return (
    <Router>
      <AppNavigationProvider>
        <div className="webos-container">
          {/* Main Content Area */}
          <div className="flex-1 overflow-hidden">
            <Routes>
              {/* Home/Launcher Route */}
              <Route path="/" element={<ShellAppLauncher />} />

              {/* App Routes */}
              <Route path="/apps/:appId/*" element={<ShellApp />} />

              {/* Fallback Route */}
              <Route path="*" element={<ShellAppLauncher />} />
            </Routes>
          </div>
        </div>
      </AppNavigationProvider>
    </Router>
  );
}
